import { render, staticRenderFns } from "./FormCrear.vue?vue&type=template&id=84edebb2&scoped=true&"
import script from "./FormCrear.vue?vue&type=script&lang=ts&"
export * from "./FormCrear.vue?vue&type=script&lang=ts&"
import style0 from "./FormCrear.vue?vue&type=style&index=0&id=84edebb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84edebb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('84edebb2', component.options)
    } else {
      api.reload('84edebb2', component.options)
    }
    module.hot.accept("./FormCrear.vue?vue&type=template&id=84edebb2&scoped=true&", function () {
      api.rerender('84edebb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Despacho/FormCrear.vue"
export default component.exports